import React, { Component, Suspense, lazy } from 'react';
import { Link } from 'react-router-dom';
import HashMap from 'hashmap';
// import dateFormat from 'dateformat';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import axios from "axios";
import '../../../src/Calendar.scss';
import { getLocalItem, getSessionItem } from '../../utils/storage';
import { trackMetaEvent } from '../../utils/metaPixel';
import Header from "../layout/header";
import Footer from "../layout/footer";
// import ReactPixel from 'react-facebook-pixel';
import Modal from '../elements/modal';
import smoothscroll from 'smoothscroll-polyfill';
import { Helmet } from 'react-helmet';
import bnrImgImport from "../../images/banner/bnr8.jpg";
const bnrImg = typeof bnrImgImport === 'object' ? bnrImgImport.default : bnrImgImport;

const ATTR_STORAGE_KEY =
	process.env.REACT_APP_ATTR_STORAGE_KEY;

// Lazy load non-critical components (skip lazy in SSR — React 17 renderToString doesn't support Suspense)
const isSSR = typeof window === 'undefined';
const Places = isSSR ? () => null : lazy(() => import('../elements/places'));
const AvailableCitiesModal = isSSR ? () => null : lazy(() => import('../elements/available-cities-modal'));

class Booking extends Component {

	dateFormat = null;
	ReactPixel = null;
	_phoneOtpCooldownTimer = null;
	_emailOtpCooldownTimer = null;
	_timePickerRef = null;
	_hourWheelRef = null;
	_minuteWheelRef = null;
	_ampmWheelRef = null;

	state = {
		isClient: false,
		isMobileApp: false,
		vehicle_category: '',
		vehicleyear: '',
		vehiclename: '',
		vehiclemileage: '',
		service: false,
		serviceName: '',
		selectedService: '',
		price: '',
		coupon: '',
		couponApplied: false,
		bookingError: '',
		locationAddress: '',
		homeAddress: '',
		city: '',
		state: '',
		zip: '',
		email: '',
		latitude: '',
		longitude: '',
		phone: '',
		datetimeError: '',
		emailError: '',
		phoneError: '',
		name: '',
		addtnl_details: '',
		isCODButtonVisible: true,
		selectedLocation: { lat:'', lng:'' },
		metaEventData: [],
		date_of_service: null,
		time_of_service: '',
		time_slot_hour: '',
		time_slot_minute: '',
		time_slot_ampm: '',
		isTimePickerOpen: false,
		isDatePickerOpen: false,
		timePickerDraftHour: '',
		timePickerDraftMinute: '',
		timePickerDraftAmPm: '',
		is_phone_verified: false,
		is_email_verified: false,
		booking_otp: '',
		email_otp: '',
		show_enter_otp_box: false,
		show_enter_email_otp_box: false,
		years: [],
		vehicle_data: [],
    vehicle_price_details: new HashMap(),
		brandNames: [],
		ccOptions: [],
		vehicleOptions: [],
    selectedBrand: '',
    selectedCCRange: '',
    filteredVehicleNames: [],
		selectedVehicle: '',
		userAddresses: [],
		selectedAddress: '',
		booking_in_progress: false,
		placesLoaded: false,

		// OTP cooldown UX (no business logic change; only prevents repeated clicks)
		isSendingPhoneOtp: false,
		isSendingEmailOtp: false,
		phoneOtpCooldownUntil: 0,
		emailOtpCooldownUntil: 0,
		phoneOtpCooldownRemaining: 0,
		emailOtpCooldownRemaining: 0,
	};

	clearOtpCooldownTimer = (kind) => {
		const key = kind === 'phone' ? '_phoneOtpCooldownTimer' : '_emailOtpCooldownTimer';
		if (this[key]) {
			clearInterval(this[key]);
			this[key] = null;
		}
	};

	startOtpCooldown = (kind, seconds = 20) => {
		const until = Date.now() + seconds * 1000;
		const untilKey = kind === 'phone' ? 'phoneOtpCooldownUntil' : 'emailOtpCooldownUntil';
		const remainingKey = kind === 'phone' ? 'phoneOtpCooldownRemaining' : 'emailOtpCooldownRemaining';

		this.clearOtpCooldownTimer(kind);

		// Set immediately so UI disables right away
		this.setState({
			[untilKey]: until,
			[remainingKey]: seconds,
		});

		const timerKey = kind === 'phone' ? '_phoneOtpCooldownTimer' : '_emailOtpCooldownTimer';
		this[timerKey] = setInterval(() => {
			const remaining = Math.max(0, Math.ceil((until - Date.now()) / 1000));
			if (this.state[remainingKey] !== remaining) {
				this.setState({ [remainingKey]: remaining });
			}
			if (remaining <= 0) {
				this.clearOtpCooldownTimer(kind);
			}
		}, 250);
	};

	isOtpCooldownActive = (kind) => {
		const untilKey = kind === 'phone' ? 'phoneOtpCooldownUntil' : 'emailOtpCooldownUntil';
		return Date.now() < (this.state[untilKey] || 0);
	};

	sendMessage = (params) => {
		axios.post("https://ridenrepair.com/auto/send_booking_confirmation", params)
		.then((res) => {
			if (res.status === 200) {
			} else {
				
			}
		});
	}

	getAttributionFromSession = () => {
		if (typeof window === 'undefined') return {};
		try {
			const raw = getSessionItem(ATTR_STORAGE_KEY);
			const parsed = raw ? JSON.parse(raw) : {};
			if (!parsed.gclid) {
				const fallbackGclid = getSessionItem(process.env.REACT_APP_GCLID_SESSION_KEY);
				if (fallbackGclid) {
					parsed.gclid = fallbackGclid;
				}
			}
			return parsed;
		} catch (e) {
			return {};
		}
	};

	storeLeadAttributionForPhone = (phone, context = {}) => {
		if (typeof window === 'undefined') return;
		if (!phone) return;

		// OTP input fires multiple times while typing; keep this idempotent per phone in-memory.
		if (context.event_type === 'phone_verified' && this._leadAttrStoredForPhone === phone) {
			return;
		}

		const attribution = this.getAttributionFromSession();
		const payload = {
			phone,
			event_type: context.event_type || 'lead',
			lead_source: context.lead_source || null,
			booking_source: context.booking_source || null,
			utm_source: attribution.utm_source || null,
			utm_medium: attribution.utm_medium || null,
			utm_campaign: attribution.utm_campaign || null,
			gclid: attribution.gclid || null,
			fbclid: attribution.fbclid || null,
			landing_url: attribution.landing_url || null,
			referrer: attribution.referrer || null,
			session_id: attribution.session_id || null,
			user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
		};

		axios
			.post('https://ridenrepair.com/api/add_lead_attribution', payload)
			.then(() => {
				if (context.event_type === 'phone_verified') {
					this._leadAttrStoredForPhone = phone;
				}
			})
			.catch(() => {});

		// Mirror into phone_leads too — booking-flow phones otherwise exist only in
		// lead_attribution (~30-40/day) and never reach the sales/voicebot pipeline.
		// add_phone_lead dedups per phone per 24h, so a phone already captured today
		// (e.g. via the phone modal) is a no-op.
		let mirrorSource = context.lead_source || null;
		if (!mirrorSource) {
			if (attribution.gclid) mirrorSource = 'google_click_ads';
			else if (attribution.fbclid) mirrorSource = 'meta_click_ads';
			else if (/google/i.test(attribution.utm_source || '')) mirrorSource = 'google_ads';
			else if (this.state.isMobileApp) mirrorSource = 'app';
			else if (typeof navigator !== 'undefined' && /mobile|android|iphone|ipad/i.test(navigator.userAgent)) mirrorSource = 'mobile_browser';
			else mirrorSource = 'desktop_browser';
		}
		axios
			.post('https://ridenrepair.com/api/add_phone_lead', { phone, lead_source: mirrorSource })
			.catch(() => {});

		if (payload.gclid) {
			axios
				.post('https://ridenrepair.com/api/store_gclid', { gclid: payload.gclid, phone })
				.then(() => {})
				.catch(() => {});
		}
	};

	validatePhone = () => {
		const phoneRegex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
		const raw = this.state.phone.replace(/\D/g, '');
		const isValidPhone = phoneRegex.test(this.state.phone);
		if (isValidPhone) {
			// Normalize to last 10 digits (strip +91, 091, 0 prefix)
			const normalized = raw.slice(-10);
			this.setState({ phone: normalized, phoneError: '' });
		} else {
			this.setState({ phoneError: 'Invalid Phone Number' });
		}
	}

	validateEmail = () => {
		const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z]{2,})+$/;
		// const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
		const isValidEmail = emailRegex.test(this.state.email);
		if (isValidEmail) {
			// email is valid
			this.setState({ emailError: '' });
		} else {
			// email is invalid
			this.setState({ emailError: 'Invalid Email' });
		}
	}

	handleChangeDateWithEvent = (newDate, event) => {
		if (event.validationError !== null) {
			this.setState({ datetimeError: 'Invalid Date or Time' })
			return;
		} else {
			this.setState({ datetimeError: '' })
			// Store as dayjs object for DatePicker, convert to string for backend when submitting
			this.setState({ date_of_service: newDate });
			if (typeof window !== 'undefined') {
				window.dataLayer.push({
					event: 'ServiceDate'
				});
			}
		}
	}

	handleDatePickerOpen = () => {
		this.setState({ isDatePickerOpen: true });
		if (typeof document !== 'undefined') {
			document.body.classList.add('picker-open');
		}
	}

	handleDatePickerClose = () => {
		this.setState({ isDatePickerOpen: false });
		if (typeof document !== 'undefined') {
			document.body.classList.remove('picker-open');
		}
	}

	handleAddressChange = (event) => {
		const selectedAddressIndex = event.target.value;
		// Check if the selected address is not the "Choose a new address" option
		if (selectedAddressIndex !== "") {
			// Find the selected address from the list of userAddresses
			const selectedAddressObj = this.state.userAddresses[selectedAddressIndex];
			// Update state with the selected address details
			this.setState({ 
				selectedAddress: selectedAddressIndex,
				homeAddress: selectedAddressObj.address,
				city: selectedAddressObj.city,
				state: selectedAddressObj.state,
				zip: selectedAddressObj.zip,
				latitude: selectedAddressObj.latitude,
				longitude: selectedAddressObj.longitude
			});
		} else {
			// Reset the address details when "Choose a new address" is selected
			this.setState({ 
				selectedAddress: selectedAddressIndex,
				homeAddress: "", // Reset the address
				city: "",       // Reset the city
				state: "",      // Reset the state
				zip: "",        // Reset the zip
				latitude: "",   // Reset the latitude
				longitude: ""   // Reset the longitude
			});
		}
	}	

	handleChangeTimeWithEvent = (newTime, event) => {
		if (event.validationError !== null) {
			return;
		}
		this.setState({ time_of_service: this.dateFormat(newTime, 'HH:MM:ss') });
	}

	// Time picker: 15-min buckets split into 3 quick selects (Hour / Minute / AM-PM)
	parseTimeOfServiceParts = (timeStr) => {
		if (!timeStr || typeof timeStr !== 'string') return null;
		const m = timeStr.match(/^(\d{2}):(\d{2}):(\d{2})$/);
		if (!m) return null;
		const hh = parseInt(m[1], 10);
		const mm = parseInt(m[2], 10);
		const ampm = hh >= 12 ? 'PM' : 'AM';
		const hour12 = ((hh + 11) % 12) + 1;
		return {
			hour: String(hour12),
			minute: String(mm).padStart(2, '0'),
			ampm,
		};
	};

	syncTimePartsFromTimeOfService = () => {
		const parts = this.parseTimeOfServiceParts(this.state.time_of_service);
		if (!parts) return;
		this.setState({
			time_slot_hour: parts.hour,
			time_slot_minute: parts.minute,
			time_slot_ampm: parts.ampm,
		});
	};

	formatTimeLabel = () => {
		const { time_slot_hour, time_slot_minute, time_slot_ampm } = this.state;
		if (!time_slot_hour || !time_slot_minute || !time_slot_ampm) return '';
		return `${String(time_slot_hour).padStart(2, '0')}:${time_slot_minute} ${time_slot_ampm}`;
	};

	getTimePickerDefaultDraft = () => {
		// Default to next quarter-hour in user's local time
		const now = dayjs();
		const add = (15 - (now.minute() % 15)) % 15;
		const next = now.add(add === 0 ? 15 : add, 'minute').second(0);
		const hh = next.hour();
		const ampm = hh >= 12 ? 'PM' : 'AM';
		const hour12 = ((hh + 11) % 12) + 1;
		const minute = String(next.minute()).padStart(2, '0');
		return { hour: String(hour12), minute, ampm };
	};

	scrollWheelToValue = (kind, value) => {
		const ITEM = 45; // keep in sync with CSS (45px item height for iOS native look)
		const getRef = () => {
			if (kind === 'hour') return this._hourWheelRef;
			if (kind === 'minute') return this._minuteWheelRef;
			return this._ampmWheelRef;
		};
		const el = getRef();
		if (!el) return;
		let idx = 0;
		if (kind === 'hour') {
			idx = Math.max(0, Math.min(11, parseInt(value || '1', 10) - 1));
		} else if (kind === 'minute') {
			const mins = ['00', '15', '30', '45'];
			idx = Math.max(0, mins.indexOf(value));
			if (idx < 0) idx = 0;
		} else {
			idx = value === 'PM' ? 1 : 0;
		}
		el.scrollTop = idx * ITEM;
	};

	openTimePicker = () => {
		if (this.state.isTimePickerOpen) return;
		// Draft starts from committed value (or a smart default) and commits on OK.
		const hasCommitted = Boolean(this.state.time_slot_hour && this.state.time_slot_minute && this.state.time_slot_ampm);
		const base = hasCommitted
			? { hour: this.state.time_slot_hour, minute: this.state.time_slot_minute, ampm: this.state.time_slot_ampm }
			: this.getTimePickerDefaultDraft();

		if (typeof document !== 'undefined') {
			document.body.classList.add('picker-open');
		}

		this.setState(
			{
				isTimePickerOpen: true,
				timePickerDraftHour: base.hour,
				timePickerDraftMinute: base.minute,
				timePickerDraftAmPm: base.ampm,
			},
			() => {
				// Let layout settle, then snap wheels to the draft selection
				requestAnimationFrame(() => {
					this.scrollWheelToValue('hour', this.state.timePickerDraftHour);
					this.scrollWheelToValue('minute', this.state.timePickerDraftMinute);
					this.scrollWheelToValue('ampm', this.state.timePickerDraftAmPm);
				});
			}
		);
	};

	closeTimePicker = () => {
		if (!this.state.isTimePickerOpen) return;
		this.setState({ isTimePickerOpen: false });
		if (typeof document !== 'undefined') {
			document.body.classList.remove('picker-open');
		}
	};

	commitTimePicker = () => {
		if (typeof document !== 'undefined') {
			document.body.classList.remove('picker-open');
		}
		this.setState(
			{
				time_slot_hour: this.state.timePickerDraftHour,
				time_slot_minute: this.state.timePickerDraftMinute,
				time_slot_ampm: this.state.timePickerDraftAmPm,
				isTimePickerOpen: false,
			},
			() => this.updateTimeOfServiceFromParts()
		);
	};

	cancelTimePicker = () => {
		if (typeof document !== 'undefined') {
			document.body.classList.remove('picker-open');
		}
		this.setState({ isTimePickerOpen: false });
	};

	handleWheelScroll = (kind) => (event) => {
		const el = event.currentTarget;
		const ITEM = 45; // keep in sync with CSS (45px item height for iOS native look)
		const idx = Math.max(0, Math.round(el.scrollTop / ITEM));
		if (kind === 'hour') {
			const hour = String(Math.max(1, Math.min(12, idx + 1)));
			if (this.state.timePickerDraftHour !== hour) this.setState({ timePickerDraftHour: hour });
		} else if (kind === 'minute') {
			const mins = ['00', '15', '30', '45'];
			const minute = mins[Math.max(0, Math.min(mins.length - 1, idx))];
			if (this.state.timePickerDraftMinute !== minute) this.setState({ timePickerDraftMinute: minute });
		} else {
			const ampm = idx >= 1 ? 'PM' : 'AM';
			if (this.state.timePickerDraftAmPm !== ampm) this.setState({ timePickerDraftAmPm: ampm });
		}
	};

	handleTimePickerOutsideClick = (event) => {
		if (!this.state.isTimePickerOpen) return;
		if (!this._timePickerRef) return;
		if (this._timePickerRef.contains(event.target)) return;
		this.closeTimePicker();
	};

	handleTimePickerKeyDown = (event) => {
		if (!this.state.isTimePickerOpen) return;
		if (event.key === 'Escape') {
			event.preventDefault();
			this.closeTimePicker();
		}
	};

	updateTimeOfServiceFromParts = (next = {}) => {
		const hour = next.time_slot_hour ?? this.state.time_slot_hour;
		const minute = next.time_slot_minute ?? this.state.time_slot_minute;
		const ampm = next.time_slot_ampm ?? this.state.time_slot_ampm;

		// Only set time_of_service once all three are selected
		if (!hour || !minute || !ampm) {
			this.setState({ time_of_service: '' });
			return;
		}

		let h = parseInt(hour, 10);
		const m = parseInt(minute, 10);
		if (Number.isNaN(h) || Number.isNaN(m)) return;
		if (ampm === 'AM') {
			if (h === 12) h = 0;
		} else {
			if (h !== 12) h += 12;
		}
		const value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:00`;
		this.setState({ time_of_service: value, datetimeError: '' }, () => {
			this.sendGATimeEvent();
		});
	};

	handleTimePartChange = (key) => (event) => {
		const value = event.target.value;
		const next = { [key]: value };
		this.setState(next, () => this.updateTimeOfServiceFromParts(next));
	};

	sendGATimeEvent = () => {
		if (this.state.time_of_service === '') {
			this.setState({ datetimeError: 'Invalid Date or Time' })
		} else {
			this.setState({ datetimeError: '' })
			if (typeof window !== 'undefined') {
				window.dataLayer.push({
					event: 'ServiceTime'
				});
			}
		}
	}

	handleChangevehicleyear = (event) => {
		this.setState({ vehicleyear: event.target.value })
		if (typeof window !== 'undefined') {
			window.dataLayer.push({
				event: 'VehicleYear'
			});
		}
	}

	handleChangevehiclename = (event) => {
		this.setState({ vehiclename: event.target.value })
		const price_info = this.state.vehicle_price_details.get(event.target.value).split(',');
		if (this.state.selectedService === 'General Service') {
			this.setState({ price: parseInt(price_info[0])});
		} else if (this.state.selectedService === 'General Service With Oil') {
			this.setState({ price: parseInt(price_info[0]) + parseInt(price_info[1])});
		} else if (this.state.selectedService === 'AMC Plan') {
			this.setState({ price: parseInt(price_info[2])});
		} else if (this.state.selectedService === 'Running Repair') {
			this.setState({ price: 450});
		}
		if (typeof window !== 'undefined') {
			window.dataLayer.push({
				event: 'VehicleMake'
			});
		}
	}

	handleChangevehiclemileage = (event) => {
		this.setState({ vehiclemileage: event.target.value })
	}

	handleBlurvehiclemileage = (event) => {
		if (typeof window !== 'undefined') {
			window.dataLayer.push({
				event: 'VehicleMileage'
			});
		}
	}

	priceDisplay = () => {
		if (this.state.selectedService === undefined || this.state.selectedService === "" || this.state.vehiclename === "" || this.state.vehiclename === undefined) {
			return (<div></div>)
		} else {
			return (
				<div>
					<h4 style = {{'text-align': 'center'}}>Rs. {this.state.price}/- only</h4>
				</div>
		)}
	}

	handleChangeservice = (event) => {
		const selectedService = event.target.value;
		this.setState({
			service: event.target.checked,
			serviceName: selectedService,
			selectedService: selectedService,
		});
	
		const selectedVehicle = this.state.vehiclename;
		const selectedVehicleData = this.state.vehicle_data.find(vehicle => vehicle.vehicle_name === selectedVehicle);
	
		const priceInfo = this.getPriceInfo(selectedService, selectedVehicleData);

		this.setState({
			isCODButtonVisible: selectedService !== 'AMC Plan',
			price: priceInfo,
		});

		if (typeof window !== 'undefined') {
			window.dataLayer.push({
				// Remove spaces
				event: selectedService.replace(/\s/g, ''),
			});
		}
	};

	onSuccessfulPayment = (response, data) => {
		const total_amount = parseFloat(data.amount) / 100;
		const service_price = total_amount / 1.18;
		const address = (this.state.homeAddress + ', ' + this.state.locationAddress).replace(/'/g, "\\'");
		const additional_details = this.state.addtnl_details.replace(/'/g, "\\'");
		const params = {
			email: this.state.email,
			first_name: this.state.name.split(' ')[0],
			last_name: this.state.name.split(' ')[1],
			phone: this.state.phone,
			address: address,
			latitude: this.state.latitude,
			longitude: this.state.longitude,
			city: this.state.city,
			state: this.state.state,
			zip: this.state.zip,
			currency: data.currency,
			vehicle_category: this.state.vehicle_category,
			vehicle_name: this.state.vehiclename,
			vehicle_year: this.state.vehicleyear,
			service_type: this.state.serviceName,
			date_of_service: this.state.date_of_service ? this.state.date_of_service.format('YYYY-MM-DD') : '',
			time_of_service: this.state.time_of_service,
			coupon_code: this.state.coupon,
			service_price: service_price.toFixed(2),
			gst: (total_amount - service_price).toFixed(2),
			total_amount: total_amount.toFixed(2),
			odometer_reading: this.state.vehiclemileage,
			payment_status: 'PAID',
			rzp_order_id: response.razorpay_order_id, 
			rzp_payment_id: response.razorpay_payment_id, 
			rzp_signature: response.razorpay_signature,
			additional_details: additional_details,
			paid_amount: total_amount,
		};

		if (typeof window !== 'undefined') {
			window.dataLayer.push({
				event: 'Purchase'
			});
		}

		axios.post("https://ridenrepair.com/api/add_booking", params, { headers: { 'Content-Type': 'application/json' } })
		.then((res) => {
			if (res.status === 200) {
				// add user vehicles & user addresses
				if (this.state.isMobileApp) {
					this.addUserAddress();
					this.addUserVehicle();
				}
				trackMetaEvent('Purchase', { value: this.state.price, currency: 'INR' });
				params['booking_id'] = res.data.id;
				if (params.coupon_code.toLowerCase() !== 'offline') {
					axios.post("https://ridenrepair.com/auto/mechanic_allocate", params);
				}
				this.sendMessage(params);
				this.props.history.push({
					pathname: '/thank-you',
					state: { params }
				});
			} else {
				this.setState({ bookingError: 'Payment unsuccessful, please try again!'});
			}
		});
	}

	validateDateTimeMinimum = () => {
		// Check if date/time is at least 30 minutes in the future
		if (!this.state.date_of_service || !this.state.time_of_service) {
			return false;
		}

		const selectedDateStr = this.state.date_of_service.format('YYYY-MM-DD');
		const selectedTimeStr = this.state.time_of_service;
		const selectedDateTime = dayjs(`${selectedDateStr} ${selectedTimeStr}`, 'YYYY-MM-DD HH:mm:ss');
		const now = dayjs();
		const minimumTime = now.add(30, 'minute');

		if (selectedDateTime.isBefore(minimumTime)) {
			this.setState({ 
				bookingError: 'Please select a date & time that is at least 30 minutes from now.',
				datetimeError: 'Please select a date & time that is at least 30 minutes from now.'
			});
			return false;
		}

		this.setState({ datetimeError: '' });
		return true;
	};

	getMissingFieldsMessage = (data) => {
		const missing = [];
		if (!data.vehiclename) missing.push('Vehicle');
		if (!data.service) missing.push('Service');
		if (!this.state.date_of_service) missing.push('Service Date');
		if (!data.time_of_service) missing.push('Service Time');
		if (!data.address) missing.push('Address');
		if (!data.city) missing.push('City');
		if (data.emailError) missing.push(`Email (${data.emailError})`);
		if (data.phoneError) missing.push(`Phone (${data.phoneError})`);
		return missing.length > 0
			? `Please fill in: ${missing.join(', ')}`
			: 'Please fill in the required fields';
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		// if (this.state.isClient && typeof this.ReactPixel.track === 'function') {
		// 	this.ReactPixel.track('InitiateCheckout');
		// }

		const tasks = [this.validateEmail, this.validatePhone];
		for (const fn of tasks) {
			await fn();
		}

		const data = {
			vehicleyear: this.state.vehicleyear,
			vehicle_category: this.state.vehicle_category,
			vehiclename: this.state.vehiclename,
			vehiclemileage: this.state.vehiclemileage,
			service: this.state.serviceName,
			date_of_service: this.state.date_of_service ? this.state.date_of_service.format('YYYY-MM-DD') : '',
			time_of_service: this.state.time_of_service,
			address: this.state.homeAddress + this.state.locationAddress,
			homeAddress: this.state.homeAddress,
			locationAddress: this.state.locationAddress,
			city: this.state.city,
			state: this.state.state,
			zip: this.state.zip,
			emailError: this.state.emailError,
			phoneError: this.state.phoneError,
		}

		if (data.vehiclename === undefined || data.service === undefined || !this.state.date_of_service || data.time_of_service === undefined || data.city === undefined || data.address === undefined ||
				data.vehiclename === '' || data.service === '' || data.time_of_service === '' || data.address === '' || data.city === ''|| data.emailError !== '' || data.phoneError !== '') {
			this.setState({ bookingError: this.getMissingFieldsMessage(data) });
			return;
		}

		// Validate date/time is at least 30 minutes in future
		if (!this.validateDateTimeMinimum()) {
			return;
		}

		if (this.state.is_phone_verified === false) {
			this.setState({ bookingError: 'Please verify your number before booking!'});
			return;
		}

		if (this.state.is_email_verified === false) {
			this.setState({ bookingError: 'Please verify your email before booking!'});
			return;
		}

		this.setState({ bookingError: ''});

		this.displayRazorpay(this.state.price);
	}

	handleCashPay = async (event) => {
		event.preventDefault();
		this.setState({ booking_in_progress: true });

		if (typeof window !== 'undefined') {
			window.dataLayer.push({ 
				email: this.state.email,
				phone: this.state.phone,
				first_name: this.state.first_name,
				last_name: this.state.last_name,
				city: this.state.city,
				state: this.state.state,
				country: 'IN',
				zip: this.state.zip 
			});
		}

		const tasks = [this.validateEmail, this.validatePhone];
		for (const fn of tasks) {
			await fn();
		}

		const eligibleCouponCodes = [
			'REPAIR150', 'IRIS150', 'WINDSOR150', 'PURVA150', 'SOBHA150', 'MARVELLA150'
		]

		if (eligibleCouponCodes.includes(this.state.coupon)  && !this.state.couponApplied) {
			this.setState({ price: (this.state.price - 150).toFixed(0)});
			this.setState({ couponApplied: true});
		}

		const data = {
			vehicleyear: this.state.vehicleyear,
			vehicle_category: this.state.vehicle_category,
			vehiclename: this.state.vehiclename,
			vehiclemileage: this.state.vehiclemileage,
			service: this.state.serviceName,
			date_of_service: this.state.date_of_service ? this.state.date_of_service.format('YYYY-MM-DD') : '',
			time_of_service: this.state.time_of_service,
			address: this.state.homeAddress + this.state.locationAddress,
			homeAddress: this.state.homeAddress,
			locationAddress: this.state.locationAddress,
			city: this.state.city,
			state: this.state.state,
			zip: this.state.zip,
			emailError: this.state.emailError,
			phoneError: this.state.phoneError,
			amount: this.state.price,
		}

		if (data.vehiclename === undefined || data.service === undefined || !this.state.date_of_service || data.time_of_service === undefined || data.city === undefined || data.address === undefined ||
				data.vehiclename === '' || data.service === '' || data.time_of_service === '' || data.address === '' ||data.city === '' || data.emailError !== '' || data.phoneError !== '') {
			this.setState({ bookingError: this.getMissingFieldsMessage(data), booking_in_progress: false });
			return;
		}

		// Validate date/time is at least 30 minutes in future
		if (!this.validateDateTimeMinimum()) {
			this.setState({ booking_in_progress: false });
			return;
		}

		if (this.state.is_phone_verified === false) {
			this.setState({ bookingError: 'Please verify your number before booking!', booking_in_progress: false });
			return;
		}

		if (this.state.is_email_verified === false) {
			this.setState({ bookingError: 'Please verify your email before booking!', booking_in_progress: false });
			return;
		}

		this.setState({ bookingError: ''});

		const isWebView = typeof window !== 'undefined' && window.ReactNativeWebView !== undefined;

		let booking_source = '';
		const attribution = this.getAttributionFromSession();

		if (attribution.gclid) {
			booking_source = 'google_click_ads';
		} else if (attribution.fbclid) {
			booking_source = 'meta_click_ads';
		} else if (isWebView) {
			if (/iPhone|iPod|iPad/.test(window.navigator.userAgent)) {
				booking_source = 'app_ios';
			} else if (/Android/.test(window.navigator.userAgent)) {
				booking_source = 'app_android';
			} else if (/Windows/.test(window.navigator.userAgent)) {
					booking_source = 'app_windows';
			} else {
				booking_source = 'app_unknown';
			}
		} else if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(window.navigator.userAgent)) {
			booking_source = 'mobile_browser';
		} else {
			booking_source = 'desktop_browser';
		}

		const address = (this.state.homeAddress + ', ' + this.state.locationAddress).replace(/'/g, "\\'");
		const additional_details = this.state.addtnl_details.replace(/'/g, "\\'");

		const total_amount = parseFloat(data.amount);
		const service_price = total_amount / 1.18;
		const params = {
			email: this.state.email,
			first_name: this.state.name.split(' ')[0],
			last_name: this.state.name.split(' ')[1],
			phone: this.state.phone,
			address: address,
			latitude: this.state.latitude,
			longitude: this.state.longitude,
			city: this.state.city,
			state: this.state.state,
			zip: this.state.zip,
			currency: 'INR',
			vehicle_category: this.state.vehicle_category,
			vehicle_name: this.state.vehiclename,
			vehicle_year: this.state.vehicleyear,
			service_type: this.state.serviceName,
			date_of_service: this.state.date_of_service ? this.state.date_of_service.format('YYYY-MM-DD') : '',
			time_of_service: this.state.time_of_service,
			coupon_code: this.state.coupon,
			booking_source: booking_source,
			service_price: service_price.toFixed(2),
			gst: (total_amount - service_price).toFixed(2),
			total_amount: total_amount.toFixed(2),
			odometer_reading: this.state.vehiclemileage,
			payment_status: 'COD',
			rzp_order_id: '', 
			rzp_payment_id: '', 
			rzp_signature: '',
			additional_details: additional_details,
			paid_amount: 0,
		};

		this.storeLeadAttributionForPhone(this.state.phone, {
			event_type: 'booking',
			booking_source: booking_source,
		});

		if (typeof window !== 'undefined') {
			window.dataLayer.push({
				event: 'Purchase'
			});
		}

		axios.post("https://ridenrepair.com/api/add_booking", params, { headers: { 'Content-Type': 'application/json' } })
		.then((res) => {
			if (res.status === 200) {
				// add user vehicles & user addresses
				if (this.state.isMobileApp) {
					this.addUserAddress();
					this.addUserVehicle();
				}
				trackMetaEvent('Purchase', {
					content_name: params.service_type,
					value: params.total_amount,
					currency: 'INR',
					em: params.email,
					ph: params.phone,
					fn: params.first_name,
					ln: params.last_name,
					ct: params.city,
					st: params.state,
					country: 'IN',
					zip: params.zip,
				});
				params['booking_id'] = res.data.id;
				if (params.coupon_code.toLowerCase() !== 'offline') {
					axios.post("https://ridenrepair.com/auto/mechanic_allocate", params);
				}
				this.sendMessage(params);
				this.props.history.push({
					pathname: '/thank-you',
					state: { params }
				});
			} else {
				this.setState({ bookingError: 'Payment unsuccessful, please try again!'});
			}
		})
		.catch((error) => {
			// Log error and set error message
			this.setState({ bookingError: 'An error occurred, please try again!' });
		})
		.finally(() => {
			this.setState({ booking_in_progress: false }); // Re-enable button and reset text
		});;
	}

	handleChange = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	}

	checkRider = (phone) => {
    return axios.get("https://ridenrepair.com/auto/check_rider", {
      params: {
        phone_number: phone
      }
    }).then(response => {
      const data = response.data;
      return data.exists;
    }).catch(error => {
      return false;
    });
  }

	handleChangeEmailOTP = (event) => {
		this.setState({ [event.target.name]: event.target.value });
	}

	handleBlurEmailOTP = (event) => {
		const params = {
			email: this.state.email,
			email_otp: this.state.email_otp
		}
		try {
			axios.post("https://ridenrepair.com/api/validate_email_otp", params, { headers: { 'Content-Type': 'application/json' } })
			.then((res) => {
				if (res.status === 200) {
					if (res.data.is_valid) {
						this.setState({ is_email_verified: true, emailError: '' });
					} else {
						this.setState({ emailError: 'Incorrect Email OTP' })
					}
				}
			});
		} catch (error) {
		}
	}

	handleChangeBookingOTP = (event) => {
		this.setState({ [event.target.name]: event.target.value });
		const params = {
			phone: this.state.phone,
			booking_otp: event.target.value
		}
		try {
			axios.post("https://ridenrepair.com/api/validate_booking_otp", params, { headers: { 'Content-Type': 'application/json' } })
			.then(async (res) => {
				if (res.status === 200) {
					this.setState({ is_phone_verified: res.data.is_valid });
					if (res.data.is_valid) {
						// OTP verified: store attribution against the verified phone for this session.
						this.storeLeadAttributionForPhone(this.state.phone, {
							event_type: 'phone_verified',
						});

						const riderExists = await this.checkRider(this.state.phone);
						if (riderExists) {
							const { cc_range, service_type } = this.props.location.state || {};
							if (cc_range === '0-199cc') {
								if (service_type === 'General Service') {
									this.setState({ price: 699 })
								} else if (service_type === 'General Service with Engine Oil') {
									this.setState({ price: 1099 })
								} else {
									this.setState({ price: 400 })
								}
							} else if (cc_range === '200-249cc') {
								if (service_type === 'General Service') {
									this.setState({ price: 749 })
								} else if (service_type === 'General Service with Engine Oil') {
									this.setState({ price: 1349 })
								} else {
									this.setState({ price: 400 })
								}
							}
						}
					}
				}
			});
		} catch (error) {
		}
	}

	startEmailVerification = async (event) => {
		if (this.state.isSendingEmailOtp || this.isOtpCooldownActive('email')) return;

		const tasks = [this.validateEmail];
		for (const fn of tasks) {
			await fn();
		}

		if (this.state.emailError !== '') {
			return;
		}

		if (this.state.email === 'support@ridenrepair.com') {
			this.setState({ is_email_verified: true, emailError: '' });
			return;
		}
		
		const params = {
			email: this.state.email
		}

		this.setState({ isSendingEmailOtp: true });
		this.startOtpCooldown('email', 20);
		axios
			.post("https://ridenrepair.com/api/send_booking_otp_email", params)
			.catch(() => {})
			.finally(() => {
				this.setState({ isSendingEmailOtp: false });
			});
		
		this.setState({ show_enter_email_otp_box: true });
	}

	startVerification = async (event) => {
		if (this.state.isSendingPhoneOtp || this.isOtpCooldownActive('phone')) return;

		const tasks = [this.validatePhone];
		for (const fn of tasks) {
			await fn();
		}

		if (this.state.phoneError !== '') {
			return;
		}
		
		const params = {
			phone: this.state.phone
		}

		this.setState({ isSendingPhoneOtp: true });
		this.startOtpCooldown('phone', 20);
		axios
			.post("https://ridenrepair.com/api/send_booking_otp_sms", params)
			.catch(() => {})
			.finally(() => {
				this.setState({ isSendingPhoneOtp: false });
			});
		
		this.setState({ show_enter_otp_box: true });
	}

	handleBlur = (event) => {
		if (typeof window !== 'undefined') {
			window.dataLayer.push({
				event: event.target.getAttribute('data-custom-event')
			});
		}
	}

	loadScript = (src) => {
		return new Promise((resolve) => {
			const script = document.createElement("script");
			script.src = src;
			script.onload = () => {
				resolve(true);
			};
			script.onerror = () => {
				resolve(false);
			};
			document.body.appendChild(script);
		});
	}

	displayRazorpay = async (amount) => {
		const res = await this.loadScript(
			"https://checkout.razorpay.com/v1/checkout.js"
		);

		if (!res) {
			alert("Razorpay SDK failed to load. Are you online?");
			return;
		}

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ amount: amount * 100, currency: 'INR' })
		};

		const data = await fetch('https://ridenrepair.com/api/razorpay', requestOptions).then(
			(response) => response.json()
		)

		const options = {
			key: 'rzp_live_v9Y9ZhDUWFgjNI',
			// key: 'rzp_live_JiAxnDUo1qXebr', // Enter the Key ID generated from the Dashboard
			// key: 'rzp_test_K9AJpedBWJr6ah',
			amount: amount,
			currency: data.currency,
			name: 'Ride N Repair',
			description: 'Service Transaction',
				image: 'https://ridenrepair.com/api/logo.png',
				order_id: data.id,
				handler: (response) => {this.onSuccessfulPayment(response, data); },
				prefill: {
					name: this.state.name,
					email: this.state.email,
					contact: this.state.phone,
				},
				notes: {
					address: this.state.homeAddress + this.state.locationAddress,
				},
				theme: {
					color: "#61dafb",
				},
		};
		
		if (typeof window !== 'undefined') {
			const paymentObject = new window.Razorpay(options);
			paymentObject.open();
		}
	}

	setLocationAddress = (locationAddress) => {
		this.setState({ locationAddress: locationAddress });
	}

	setCity = (city) => {
		this.setState({ city: city });
	}

	setStateValue = (state) => {
		this.setState({ state: state });
	}

	setZip = (zip) => {
		this.setState({ zip: zip });
	}

	setLatitude = (latitude) => {
		this.setState({ latitude: latitude });
	}

	setLongitude = (longitude) => {
		this.setState({ longitude: longitude });
	}

	scrollToBookingForm = () => {
		smoothscroll.polyfill();
		if (this.formSection) {
			this.formSection.scrollIntoView({ behavior: "smooth", block: "start" });
		}
	}

	componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      // Check if the location has changed (indicating a redirection)
      this.scrollToBookingForm();
    }
  }

	getPriceInfo = (selectedService, vehicleData) => {
		switch (selectedService) {
			case 'General Service':
				return vehicleData.general_service_price;
			case 'General Service With Oil':
				return vehicleData.general_service_price + vehicleData.engine_oil_price;
			case 'AMC Plan':
				return vehicleData.amc_plan_price;
			case 'Running Repair':
				return 450; // Assuming a default value for "Running Repair"
			default:
				return 10000; // Default value if service is not recognized
		}
	};

	addUserVehicle = () => {
		const { vehicle_category, brand, vehicle_name, transmission, fuel_type, cc_range } = this.props.location.state || {};
		const vehicleData = {
			brand: brand,
			cc_range: cc_range,
			fuel_type: fuel_type,
			model: vehicle_name,
			phone: this.props.user.ph,
			transmission: transmission,
			vehicle_type: vehicle_category
		};
		
		axios.post("https://ridenrepair.com/api/add_user_vehicle", vehicleData)
		.then((res) => {
			if (res.status === 200) {
			} else {
			}
		});
	}

	addUserAddress = () => {
		const addressData = {
			phone: this.props.user.ph,
			address: this.state.homeAddress,
			latitude: this.state.latitude,
			longitude: this.state.longitude,
			city: this.state.city,
			state: this.state.state,
			zip: this.state.zip
		};
		
		axios.post("https://ridenrepair.com/api/add_user_address", addressData)
		.then((res) => {
			if (res.status === 200) {
			} else {
			}
		});
	}

	componentDidMount(){
		// Set initial state first for better performance
		this.setState({ 
			isClient: true,
			serviceName: this.props.location.state?.service_type || '',
			vehiclename: this.props.location.state?.vehicle_name || '',
			vehicle_category: this.props.location.state?.vehicle_category || '',
			price: this.props.location.state?.price || '',
			email: this.props.user.is_logged ? this.props.user.email : '',
			phone: this.props.user.is_logged ? this.props.user.ph : '',
			is_phone_verified: this.props.user.is_logged,
			is_email_verified: this.props.user.is_logged
		});

		const isWebView = typeof window !== 'undefined' && window.ReactNativeWebView !== undefined;

    if (isWebView) {
			this.setState({
				isMobileApp: true,
				email: this.props.user.email,
				phone: this.props.user.ph,
				name: `${this.props.user.fn} ${this.props.user.ln}`,
				is_phone_verified: this.props.user.is_logged,
				is_email_verified: this.props.user.is_logged
			});

			// Load user addresses for mobile app
			this.loadUserAddresses();
    }
		
		// Initialize client-side features
		if (typeof window !== 'undefined') {
			if (getLocalItem('phone_provided') !== 'yes' && getSessionItem('phone_ignored') !== 'yes') {
				this.props.setOpenModal(true);
			}
			
			// Lazy load dateformat for better performance
			import('dateformat').then((dateFormatModule) => {
				this.dateFormat = dateFormatModule.default;
			}).catch((error) => {
				console.error('Error loading dateformat:', error);
			});
			
			trackMetaEvent('InitiateCheckout');
			trackMetaEvent('AddToCart');
			
			window.dataLayer.push({
				event: 'BookNow'
			});
		}
		
		// Load data in parallel for better performance
		this.loadYears();
		this.loadVehicleData();
		this.scrollToBookingForm();
		this.syncTimePartsFromTimeOfService();

		if (typeof document !== 'undefined') {
			document.addEventListener('mousedown', this.handleTimePickerOutsideClick);
			document.addEventListener('keydown', this.handleTimePickerKeyDown);
		}
	}

	componentWillUnmount() {
		this.clearOtpCooldownTimer('phone');
		this.clearOtpCooldownTimer('email');
		if (typeof document !== 'undefined') {
			document.removeEventListener('mousedown', this.handleTimePickerOutsideClick);
			document.removeEventListener('keydown', this.handleTimePickerKeyDown);
			// Clean up picker-open class if component unmounts while picker is open
			document.body.classList.remove('picker-open');
		}
	}

	loadUserAddresses = async () => {
		try {
			const response = await axios.get("https://www.ridenrepair.com/api/get_user_addresses", {
				params: { phone: this.props.user.ph }
			});
			
			if (response.status === 200) {
				this.setState({ userAddresses: response.data.addresses });

				if (response.data.addresses.length > 0) {
					const firstAddress = response.data.addresses[0];
					this.setState({ 
						selectedAddress: 0,
						homeAddress: firstAddress.address,
						city: firstAddress.city,
						state: firstAddress.state,
						zip: firstAddress.zip,
						latitude: firstAddress.latitude,
						longitude: firstAddress.longitude
					});
				}
			}
		} catch (error) {
			console.error('Error loading user addresses:', error);
		}
	}

	loadYears = async () => {
		try {
			const response = await axios.get("https://ridenrepair.com/api/years", { mode: "no-cors" });
			this.setState({ years: response.data });
		} catch (error) {
			console.error('Error loading years:', error);
		}
	}

	loadVehicleData = async () => {
		try {
			const response = await axios.get("https://ridenrepair.com/api/vehicle_name", { mode: "no-cors" });
			const vehicle_data = response.data.map(item => ({
				vehicle_name: item.vehicle_name,
				brand_name: item.brand_name,
				vehicle_cc: item.vehicle_cc,
				general_service_price: item.general_service_price,
				engine_oil_price: item.engine_oil_price,
				amc_plan_price: item.amc_plan_price,
			}));

			// Sort by brand, then by CC, and finally by vehicle name
			vehicle_data.sort((a, b) => {
				if (a.brand_name !== b.brand_name) {
					return a.brand_name.localeCompare(b.brand_name);
				}
				if (a.vehicle_cc !== b.vehicle_cc) {
					return a.vehicle_cc - b.vehicle_cc;
				}
				return a.vehicle_name.localeCompare(b.vehicle_name);
			});

			// Extract unique brand names, CC options, and vehicle names
			const brandNames = Array.from(new Set(vehicle_data.map(item => item.brand_name)));
			const ccOptions = Array.from(new Set(vehicle_data.map(item => item.vehicle_cc)));
			const vehicleOptions = Array.from(new Set(vehicle_data.map(item => item.vehicle_name)));

			this.setState({
				vehicle_data,
				brandNames,
				ccOptions,
				vehicleOptions,
				filteredVehicleNames: vehicle_data,
			});
		} catch (error) {
			console.error('Error loading vehicle data:', error);
		}
	}

	handleBrandChange = (event) => {
		const selectedBrand = event.target.value;
		const filteredVehicleNames = this.filterVehicleNames(selectedBrand, this.state.selectedCCRange);
		this.setState({
			selectedBrand,
			filteredVehicleNames,
			vehiclename: "", // Reset selected vehicle when CC range changes
		});
	};

	handleCCRangeChange = (event) => {
		const selectedCCRange = event.target.value;
		const filteredVehicleNames = this.filterVehicleNames(this.state.selectedBrand, selectedCCRange);
		this.setState({
			selectedCCRange,
			filteredVehicleNames,
			vehiclename: "", // Reset selected vehicle when CC range changes
		});
	};

	handleVehicleChange = (event) => {
		const vehiclename = event.target.value;
		this.setState({
			vehiclename,
			serviceName: "",
			selectedService: "",
			isCODButtonVisible: false
		});
	};

	filterVehicleNames = (brand, ccRange) => {
		if (!brand && !ccRange) {
			return this.state.vehicle_data;
		}
	
		return this.state.vehicle_data
			.filter((vehicle) => {
				const brandFilter = !brand || vehicle.brand_name === brand;
				const ccRangeFilter = ccRange === null || this.isVehicleInCCRange(vehicle.vehicle_cc, ccRange);
				return brandFilter && ccRangeFilter;
			})
			.map((vehicle) => ({
				vehicle_name: vehicle.vehicle_name,
				brand_name: vehicle.brand_name,
				vehicle_cc: vehicle.vehicle_cc,
				general_service_price: vehicle.general_service_price,
				engine_oil_price: vehicle.engine_oil_price,
				amc_plan_price: vehicle.amc_plan_price,
			}));
	};	
	
	isVehicleInCCRange = (vehicleCC, ccRange) => {
		let [min, max] = ccRange.split('-').map(Number);
		if (isNaN(min)) {
			min = 801;
			max = Infinity;
		}
		return vehicleCC >= min && (isNaN(max) || vehicleCC <= max);
	};
	
	render() {

		const canonicalUrl = 'https://www.ridenrepair.com/booking';

		return (
			<div className="rr-booking rr-booking--lux">
				<Helmet>
					<link rel="canonical" href={canonicalUrl} />
					<title>Book Service - Ride N Repair</title>
					<meta name="description" content="Conveniently book your bike service online with Ride N Repair. Schedule a time, and our expert mechanics will come to your doorstep for seamless repairs and maintenance." />
					<meta name="keywords" content="Online Booking, Ride N Repair, Doorstep Bike Service, Book Bike Service, Schedule Service, Expert Mechanics" />
				</Helmet>

				{this.props.citiesModal && (
					<Suspense fallback={<div>Loading...</div>}>
						<AvailableCitiesModal closeModal={() => this.props.setCitiesModal(false)} />
					</Suspense>
				)}

				{!this.state.isMobileApp && this.props.openModal && <Modal openModal={this.props.openModal} setOpenModal={this.props.setOpenModal} user={this.props.user} setUser={this.props.setUser} />}
			
				<Header user={this.props.user} setUser={this.props.setUser} isMobileApp={this.props.isMobileApp} />
				<div className="page-content bg-white">

					<div className="page-banner ovbl-dark" style={ this.state.isClient ? { backgroundImage: "url(" + bnrImg + ")" } : {} }>
						<div className="container">
							<div className="page-banner-entry text-center">
								<h1><span>Booking</span></h1>
								<nav aria-label="breadcrumb" className="breadcrumb-row">
									<ul className="breadcrumb">
										<li className="breadcrumb-item"><Link to="/"><i className="las la-home"></i>Home</Link></li>
										<li className="breadcrumb-item active" aria-current="page">Booking</li>
									</ul>
								</nav>
							</div>
						</div>
					</div>

					<div className="booking-container" ref={ref => (this.formSection = ref)}>
						<section className="section-area section-sp1">
							<div className="container">
								<div className="row">
									<div className="col-lg-8 col-md-7 mb-md-50">
										<form className="booking-form">
											<div className="row">
												
												<div className="col-lg-12">
													<div className="form-group">
														<h6 className="form-title">SELECT EXACT SERVICE ADDRESS</h6>
														<div className="row">
															{this.state.isMobileApp && (
																<div style={{ display: 'flex', justifyContent: 'left' }}>
																	<select 
																		value={this.state.selectedAddress}
																		onChange={this.handleAddressChange}
																		style={{ width: '75%', textAlign: 'center', marginBottom: '5%' }}
																	>
																		<option value="">Choose a new address</option>
																		{this.state.userAddresses.map((address, index) => (
																			<option key={index} value={index}>
																				{address.address}, {address.city}, {address.state} - {address.zip}
																			</option>
																		))}
																	</select>
																</div>
															)}
															{!this.state.isMobileApp || (this.state.isMobileApp && this.state.selectedAddress === "") ? (
																<div className="col-xl-12 col-sm-6">
																	{isSSR ? null : (
																		<Suspense fallback={<div>Loading map...</div>}>
																			<Places setLocationAddress={this.setLocationAddress} setCity={this.setCity} setStateValue={this.setStateValue} setZip={this.setZip} setLatitude={this.setLatitude} setLongitude={this.setLongitude} isMobileApp={this.state.isMobileApp}/>
																		</Suspense>
																	)}
																</div>
															) : null}
															{!this.state.isMobileApp || (this.state.isMobileApp && this.state.selectedAddress === "") ? (
																<div className="col-xl-12 col-sm-6" style={{paddingTop: '30px', 'width': '100%'}}>
																	<div className="form-group">
																		<input type="text" name="homeAddress" data-custom-event="homeAddress" className="form-control" placeholder="Complete your address with House No" value={this.state.homeAddress} onChange={this.handleChange} onBlur={this.handleBlur}/>
																	</div>
																</div>
															) : null}
														</div>
													</div>
												</div>

												<div className="col-lg-12">
													<div className="form-group">
														<h6 className="form-title">FILL YOUR INFORMATION</h6>
														<div className="row">
															<div className="col-lg-6 col-12">
																<div className="form-group">
																	<div className="rr-field-row rr-field-row--email">
																		<input
																			type="email"
																			name="email"
																			data-custom-event="EnterEmail"
																			className={`form-control ${this.state.is_email_verified ? 'is-verified' : ''}`}
																			placeholder="Email (for Invoice)"
																			value={this.state.email}
																			onChange={this.handleChange}
																			onBlur={this.handleBlur}
																			disabled={this.state.isMobileApp || this.props.user.is_logged}
																		/>
																		{!this.state.isMobileApp && !this.props.user.is_logged && (
																			<div
																				className={`verify-link ${(this.state.isSendingEmailOtp || this.state.emailOtpCooldownRemaining > 0) ? 'is-disabled' : ''}`}
																				onClick={this.startEmailVerification}
																				aria-disabled={(this.state.isSendingEmailOtp || this.state.emailOtpCooldownRemaining > 0) ? 'true' : 'false'}
																			>
																				{(this.state.isSendingEmailOtp || this.state.emailOtpCooldownRemaining > 0)
																					? `Wait ${this.state.emailOtpCooldownRemaining || 20}s`
																					: 'Verify'}
																			</div>
																		)}
																		{this.state.emailError && <p>{this.state.emailError}</p>}
																	</div>
																</div>
															</div>
															<div className="col-lg-6 col-12">
																<div className="form-group">
																	<div className="rr-field-row rr-field-row--phone">
																		<div className="phone-prefix rr-phone-prefix">+91&nbsp;</div>
																		<input
																			type="text"
																			name="phone"
																			data-custom-event="EnterPhone"
																			className={`form-control ${this.state.is_phone_verified ? 'is-verified' : ''}`}
																			placeholder="Phone Number"
																			value={this.state.phone}
																			onChange={this.handleChange}
																			onBlur={this.handleBlur}
																			disabled={this.state.isMobileApp || this.props.user.is_logged}
																		/>
																		{!this.state.isMobileApp && !this.props.user.is_logged && (
																			<div
																				className={`verify-link ${(this.state.isSendingPhoneOtp || this.state.phoneOtpCooldownRemaining > 0) ? 'is-disabled' : ''}`}
																				onClick={this.startVerification}
																				aria-disabled={(this.state.isSendingPhoneOtp || this.state.phoneOtpCooldownRemaining > 0) ? 'true' : 'false'}
																			>
																				{(this.state.isSendingPhoneOtp || this.state.phoneOtpCooldownRemaining > 0)
																					? `Wait ${this.state.phoneOtpCooldownRemaining || 20}s`
																					: 'Verify'}
																			</div>
																		)}
																		{this.state.phoneError && <p>{this.state.phoneError}</p>}
																	</div>
																</div>
															</div>
															<div className="col-lg-12 col-12">
																<div className="form-group">
																	<input
																		type="text"
																		name="name"
																		data-custom-event="EnterName"
																		className="form-control"
																		placeholder="Name (Optional)"
																		value={this.state.isMobileApp ? `${this.props.user.fn} ${this.props.user.ln}` : this.state.name}
																		onChange={this.handleChange}
																		onBlur={this.handleBlur}
																		disabled={this.state.isMobileApp}
																	/>
																</div>
															</div>
															<div className="col-lg-6 col-12">
																{this.state.show_enter_email_otp_box && (
																	<div className="form-group">
																		<input
																			style={{ border: this.state.is_email_verified ? '2px solid green' : '' }}
																			type="text"
																			name="email_otp"
																			data-custom-event="EnterEmailOTP"
																			className="form-control"
																			placeholder="Enter Email OTP"
																			value={this.state.email_otp}
																			onChange={this.handleChangeEmailOTP}
																			onBlur={this.handleBlurEmailOTP}
																		/>
																	</div>
																)}
															</div>
															<div className="col-lg-6 col-12">
																{this.state.show_enter_otp_box && (
																	<div className="form-group">
																		<input
																			style={{ border: this.state.is_phone_verified ? '2px solid green' : '' }}
																			type="text"
																			name="booking_otp"
																			data-custom-event="EnterOTP"
																			className="form-control"
																			placeholder="Enter OTP"
																			value={this.state.booking_otp}
																			onChange={this.handleChangeBookingOTP}
																		/>
																	</div>
																)}
															</div>
															<div className="col-lg-12 col-12"></div>
														</div>
													</div>
												</div>

												<div className="col-lg-12">
													<div className="form-group">
														<h6 className="form-title">SELECT DATE and TIME</h6>
														<p>*Please select a date & time for your service that is at least 30 minutes from the current time.</p>
													</div>
												</div>
												<div className="col-lg-12">
													<div className="col-lg-8 col-12 mx-auto">
														<div className="form-group">
															<LocalizationProvider dateAdapter={AdapterDayjs}>
																<div className="date-time-wrapper">
																	<DatePicker
																		className="custom-calendar"
																		label="Date"
																		value={this.state.date_of_service}
																		onChange={this.handleChangeDateWithEvent}
																		onOpen={this.handleDatePickerOpen}
																		onClose={this.handleDatePickerClose}
																		minDate={dayjs()}
																	/>
																	<div
																		className="rr-time"
																		ref={(ref) => (this._timePickerRef = ref)}
																	>
																		<button
																			type="button"
																			className="rr-time-trigger"
																			onClick={this.openTimePicker}
																			disabled={this.state.date_of_service === undefined || this.state.date_of_service === ''}
																			aria-haspopup="dialog"
																			aria-expanded={this.state.isTimePickerOpen ? 'true' : 'false'}
																		>
																			<span className="rr-time-trigger__label">Time</span>
																			<span className="rr-time-trigger__value">
																				{this.formatTimeLabel() || 'Select time'}
																			</span>
																		</button>

																		{this.state.isTimePickerOpen && (
																			<div className="rr-time-popover" role="dialog" aria-label="Select time">
																				<div className="rr-time-popover__header">
																					<button
																						type="button"
																						className="rr-time-popover__cancel"
																						onClick={this.cancelTimePicker}
																					>
																						Cancel
																					</button>
																					<div className="rr-time-popover__title">Select Time</div>
																					<button
																						type="button"
																						className="rr-time-popover__done"
																						onClick={this.commitTimePicker}
																					>
																						OK
																					</button>
																				</div>

																				<div className="rr-time-wheel" role="group" aria-label="Time picker">
																					<div className="rr-time-wheel__highlight" aria-hidden="true"></div>
																					<div className="rr-time-wheel__cols">
																					<div className="rr-time-col">
																						<div className="rr-time-col__label">Hour</div>
																						<div
																							className="rr-time-wheel__col"
																							onScroll={this.handleWheelScroll('hour')}
																							ref={(ref) => (this._hourWheelRef = ref)}
																						>
																							<div className="rr-time-wheel__pad" />
																							{Array.from({ length: 12 }, (_, i) => i + 1).map((h) => {
																								const v = String(h);
																								const isActive = this.state.timePickerDraftHour === v;
																								return (
																									<div 
																										key={v} 
																										className={`rr-time-wheel__item ${isActive ? 'is-active' : ''}`}
																										onClick={() => {
																											this.setState({ timePickerDraftHour: v });
																											this.scrollWheelToValue('hour', v);
																										}}
																									>
																										{String(h).padStart(2, '0')}
																									</div>
																								);
																							})}
																							<div className="rr-time-wheel__pad" />
																						</div>
																					</div>

																					<div className="rr-time-col">
																						<div className="rr-time-col__label">Minute</div>
																						<div
																							className="rr-time-wheel__col"
																							onScroll={this.handleWheelScroll('minute')}
																							ref={(ref) => (this._minuteWheelRef = ref)}
																						>
																							<div className="rr-time-wheel__pad" />
																							{['00', '15', '30', '45'].map((m) => {
																								const isActive = this.state.timePickerDraftMinute === m;
																								return (
																									<div 
																										key={m} 
																										className={`rr-time-wheel__item ${isActive ? 'is-active' : ''}`}
																										onClick={() => {
																											this.setState({ timePickerDraftMinute: m });
																											this.scrollWheelToValue('minute', m);
																										}}
																									>
																										{m}
																									</div>
																								);
																							})}
																							<div className="rr-time-wheel__pad" />
																						</div>
																					</div>

																					<div className="rr-time-col">
																						<div className="rr-time-col__label">AM/PM</div>
																						<div
																							className="rr-time-wheel__col"
																							onScroll={this.handleWheelScroll('ampm')}
																							ref={(ref) => (this._ampmWheelRef = ref)}
																						>
																							<div className="rr-time-wheel__pad" />
																							{['AM', 'PM'].map((p) => {
																								const isActive = this.state.timePickerDraftAmPm === p;
																								return (
																									<div 
																										key={p} 
																										className={`rr-time-wheel__item ${isActive ? 'is-active' : ''}`}
																										onClick={() => {
																											this.setState({ timePickerDraftAmPm: p });
																											this.scrollWheelToValue('ampm', p);
																										}}
																									>
																										{p}
																									</div>
																								);
																							})}
																							<div className="rr-time-wheel__pad" />
																						</div>
																					</div>
																					</div>
																					<div className="rr-time-wheel__fade rr-time-wheel__fade--top" aria-hidden="true"></div>
																					<div className="rr-time-wheel__fade rr-time-wheel__fade--bottom" aria-hidden="true"></div>
																				</div>
																			</div>
																		)}
																	</div>
																	{this.state.datetimeError && <p>{this.state.datetimeError}</p>}
																</div>
															</LocalizationProvider>
														</div>
													</div>
												</div>
												<div className="col-lg-12">
													<div className="form-group">
														<h6 className="form-title">ADDITIONAL NOTES</h6>
														<div className="row">
															<div className="col-xl-12 col-sm-6">
																<div className="form-group">
																	<input type="text" name="addtnl_details" data-custom-event="addtnl_details" className="form-control" placeholder="Please explain what is the issue, if any, with your vehicle in detail" value={this.state.addtnl_details} onChange={this.handleChange} onBlur={this.handleBlur}/>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="col-lg-6">
													<div className="form-group">
														<input name="coupon" data-custom-event="coupon" type="coupon" className="form-control"  placeholder="Discount Coupon" value={this.state.coupon} onChange={this.handleChange} onBlur={this.handleBlur}/>
													</div>
												</div>
												<div className="col-lg-12">
													<p/><div style={{ fontSize: 'x-small' }}><b>*Amount paid will be adjusted from the total bill. You can cancel any time: if you cancel before our mechanic reaches your location, a full refund will be issued for all charged amounts. All prices are inclusive of GST. Once our mechanic reaches your location, a visit charge of Rs 399/- applies, whether or not a service/repair is performed.</b><p/></div>
													<p>{this.state.bookingError}</p>
													<p>
														<Link className="btn btn-primary btn-lg" onClick={this.handleSubmit}>Pay Now</Link>&nbsp;&nbsp;&nbsp;&nbsp;
														{this.state.isCODButtonVisible && (
															<Link 
																className="btn btn-primary btn-lg" 
																onClick={this.handleCashPay} 
																disabled={this.state.booking_in_progress}
															>
																{this.state.booking_in_progress ? 'Booking...' : 'Pay Later'}
															</Link>
														)}
														{/* {this.state.isCODButtonVisible && ( <Link className="btn btn-primary btn-lg" onClick={this.handleCashPay} disabled={this.state.booking_in_progress}>Pay Later</Link> )} */}
													</p>
												</div>
											</div>
										</form>
									</div>
									<div className="col-lg-4 col-md-5">
										<aside>
											<div className="widget">
												<ul className="service-menu style-1">
													<li><Link to="/about">About Us <i className="las la-question-circle"></i></Link></li>
													<li><Link to="/service">Our Services <i className="las la-cog"></i></Link></li>
													<li className="active"><Link to="/booking">Booking<i className="lab la-wpforms"></i></Link></li>
													<li><Link to="/faq">Faq<i className="las la-quote-left"></i></Link></li>
												</ul>
											</div>
										</aside>
									</div>
								</div>
							</div>
						</section>
					</div>



				</div>

				<Footer setCitiesModal={this.props.setCitiesModal} />

			</div>
		);
	}
}

export default Booking;